export function validateNegativeNumber(value?: string | number) {
  return !(isNaN(Number(value)) || Number(value) < 0);
}
